'use client'
import * as React from 'react'
import dynamic from 'next/dynamic'

import type { MultiContentSearchInputProps } from '../multiple-index-search-input'
import type { MultiContentAndCategoriesSearchInputProps } from '../multiple-index-and-categories-search-input'
import { SearchInput } from './input'

const ContentSearchInputComponent = dynamic(
  () => import('.').then(mod => mod.ContentSearchInputImpl),
  {
    ssr: false,
    loading: () => <SearchInput />,
  },
)

const MultiSearchInputComponent = dynamic(() => import('.').then(mod => mod.MultiSearchInputImpl), {
  ssr: false,
  loading: () => <SearchInput />,
})

const MultiContentAndCategoriesSearchInputComponent = dynamic(
  () => import('.').then(mod => mod.MultiContentAndCategoriesSearchInputImpl),
  {
    ssr: false,
    loading: () => <SearchInput />,
  },
)

const ContentSearchPageSearchInputComponent = dynamic(
  () => import('.').then(mod => mod.ContentSearchPageSearchInputImpl),
  {
    ssr: false,
    loading: () => <SearchInput />,
  },
)

const LegacyContentInputComponent = dynamic(
  () => import('.').then(mod => mod.LegacyContentSearchInputImpl),
  {
    ssr: false,
    loading: () => <SearchInput />,
  },
)

export const ContentSearchPageSearchInput = ({
  placeholder,
  no_results_text,
  searchSource,
}: {
  placeholder: string
  no_results_text?: string
  searchSource: string
}) => {
  return (
    <ContentSearchPageSearchInputComponent
      placeholder={placeholder}
      no_results_text={no_results_text}
      searchSource={searchSource}
    />
  )
}

export const ContentSearchInput = ({
  filters,
  placeholder,
  href,
  enableAutocomplete,
  no_results_text,
  searchSource,
}: {
  filters: string
  placeholder: string
  href?: string
  enableAutocomplete?: boolean
  no_results_text?: string
  searchSource: string
}) => {
  return (
    <ContentSearchInputComponent
      filters={filters}
      enableAutocomplete={enableAutocomplete}
      href={href}
      placeholder={placeholder}
      no_results_text={no_results_text}
      searchSource={searchSource}
    />
  )
}

export function LegacyContentSearchInput({
  filters,
  placeholder,
  href,
  enableAutocomplete,
  no_results_text,
  searchSource,
}: {
  filters: string
  placeholder: string
  href?: string
  enableAutocomplete?: boolean
  no_results_text?: string
  searchSource: string
}) {
  return (
    <LegacyContentInputComponent
      filters={filters}
      enableAutocomplete={enableAutocomplete}
      href={href}
      placeholder={placeholder}
      no_results_text={no_results_text}
      searchSource={searchSource}
    />
  )
}

export const MultiContentSearchInput = ({
  filters,
  ...inputProps
}: MultiContentSearchInputProps & { filters?: string }) => {
  return <MultiSearchInputComponent filters={filters} {...inputProps} />
}

export const MultiContentAndCategoriesSearchInput = ({
  filters,
  ...inputProps
}: MultiContentAndCategoriesSearchInputProps & { filters?: string }) => {
  return <MultiContentAndCategoriesSearchInputComponent filters={filters} {...inputProps} />
}
